import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../config/api";
import { useSuccessMessageStore } from "../../stores/successMessageStore";
import PageHeaderTitle from "../../componenets/main/pageTitle";

import "../../assets/css/contents/ask.css";
import Modal from "../../componenets/main/modal";

export default function AskPage() {
    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);
    const [account, setAccount] = useState({
        companyName: "",
        clientName: "",
        contact: "",
        clientPosition: "",
        email: "",
        content: "",
        type: "",
        companySize: "",
    });

    const [errors, setErrors] = useState({ contact: "", email: "" });
    const [touched, setTouched] = useState({
        companyName: false,
        clientName: false,
        contact: false,
        clientPosition: false,
        email: false,
        type: false,
        companySize: false,
    });

    const [isAgreed, setIsAgreed] = useState(false);

    const onChangeAccount = (e) => {
        setAccount({
            ...account,
            [e.target.name]: e.target.value,
        });
    };

    const handleBlur = (e) => {
        const { name } = e.target;
        setTouched((prev) => ({ ...prev, [name]: true }));
    };

    const handleAgreementChange = (e) => {
        setIsAgreed(e.target.checked);
    };

    const validateEmail = (email) => {
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
    };

    const validatePhone = (contact) => {
        const cleaned = contact.replace(/[^0-9]/g, "");
        return cleaned.length >= 10 && cleaned.length <= 11;
    };

    const form = useRef();
    const onSubmit = async (e) => {
        e.preventDefault();

        // 유효성 검사
        if (!isAgreed) {
            alert("개인정보 제공에 동의해주세요.");
            return;
        }

        if (!account.type || account.type === "0") {
            alert("문의분야를 선택해주세요.");
            return;
        }

        if (
            !account.companyName ||
            !account.clientName ||
            !account.contact ||
            !account.clientPosition ||
            !account.email
        ) {
            alert("모든 필수 항목을 입력해주세요.");
            return;
        }

        if (!validatePhone(account.contact)) {
            setErrors((prev) => ({ ...prev, contact: "올바른 전화번호 형식을 입력하세요." }));
            return;
        }

        if (!validateEmail(account.email)) {
            setErrors((prev) => ({ ...prev, email: "유효한 이메일 주소를 입력하세요." }));
            return;
        }

        try {
            const requestData = {
                title: "브로넥스 문의사항",
                companyName: account.companyName,
                clientName: account.clientName,
                contact: account.contact,
                clientPosition: account.clientPosition,
                email: account.email,
                content: account.content || "",
                type: account.type,
                companySize: account.companySize,
                collaborationToolEnabled: false,
            };

            // 성공 메시지 설정
            const { setSuccess } = useSuccessMessageStore.getState();
            setSuccess("문의가 성공적으로 접수되었습니다.");

            // API 호출
            const response = await api.post("/api/v1/qnas/domain/16", requestData);

            // 폼 초기화
            setAccount({
                companyName: "",
                clientName: "",
                contact: "",
                clientPosition: "",
                email: "",
                content: "",
                type: "",
                companySize: "",
            });
            setIsAgreed(false);
            setErrors({ contact: "", email: "" });
            setTouched({
                companyName: false,
                clientName: false,
                contact: false,
                clientPosition: false,
                email: false,
                type: false,
                companySize: false,
            });

            // 홈으로 이동
            navigate("/");
        } catch (error) {
            console.error("문의 접수 실패:", error);
            // 에러는 interceptor에서 자동으로 alert 처리됨
        }
    };

    return (
        <>
            <PageHeaderTitle
                title="문의하기"
                subTitle="broanex"
                etc="회사나 프로그램 구축에 대해 궁금한 점이 있다면 문의글을 남겨주세요."
            />
            <div className="background-gray">
                <div className="contents_inner_container_layout ask-contents-width">
                    <div className="ask-message-box">
                        <div className="ask-cover">
                            <img src="img/message.png" alt="메세지 아이콘" />
                        </div>

                        <div>
                            <p>
                                정확한 상담을 위해 아래 항목을 모두 입력해주세요. 담당자가 연락처 또는 이메일로
                                답변해드립니다.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <section className="contents_container_layout">
                <div className="contents_inner_container_layout">
                    <form onSubmit={onSubmit} ref={form}>
                        <div className="ask-form-content">
                            <div className="ask-form-item">
                                <label>
                                    문의분야 <span style={{ color: "red" }}>*</span>
                                </label>
                                <select
                                    className="form-control"
                                    name="type"
                                    onChange={onChangeAccount}
                                    onBlur={handleBlur}
                                    value={account.type}
                                >
                                    <option value="0">선택해주세요.</option>
                                    <option value="MES">MES</option>
                                    <option value="Analytics">Analytics</option>
                                    <option value="QMS">QMS</option>
                                    <option value="MC">MC</option>
                                    <option value="MB">MB</option>
                                    <option value="ACS솔루션">ACS솔루션</option>
                                    <option value="ACS시뮬레이션">ACS시뮬레이션</option>
                                    <option value="기타">기타</option>
                                </select>
                                {touched.type && (!account.type || account.type === "0") && (
                                    <p style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
                                        필수 입력 항목입니다.
                                    </p>
                                )}
                            </div>
                            <div className="ask-form-item">
                                <label>
                                    회사명 <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    id="companyName"
                                    name="companyName"
                                    onChange={onChangeAccount}
                                    onBlur={handleBlur}
                                    value={account.companyName}
                                    className="form-control"
                                    placeholder="회사명을 입력하세요"
                                />
                                {touched.companyName && !account.companyName && (
                                    <p style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
                                        필수 입력 항목입니다.
                                    </p>
                                )}
                            </div>
                            <div className="ask-form-item">
                                <label>
                                    이름 <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    id="clientName"
                                    name="clientName"
                                    onChange={onChangeAccount}
                                    onBlur={handleBlur}
                                    value={account.clientName}
                                    className="form-control"
                                    placeholder="이름을 입력하세요"
                                />
                                {touched.clientName && !account.clientName && (
                                    <p style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
                                        필수 입력 항목입니다.
                                    </p>
                                )}
                            </div>
                            <div className="ask-form-item">
                                <label>
                                    연락처 <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="tel"
                                    id="contact"
                                    name="contact"
                                    onChange={onChangeAccount}
                                    onBlur={handleBlur}
                                    value={account.contact}
                                    placeholder="- 를 제외하고 입력해주세요"
                                    className="form-control"
                                />
                                {errors.contact && (
                                    <p style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>{errors.contact}</p>
                                )}
                                {touched.contact && !account.contact && (
                                    <p style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
                                        필수 입력 항목입니다.
                                    </p>
                                )}
                            </div>
                            <div className="ask-form-item">
                                <label>
                                    직급 <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    id="clientPosition"
                                    name="clientPosition"
                                    onChange={onChangeAccount}
                                    onBlur={handleBlur}
                                    value={account.clientPosition}
                                    placeholder="직급을 입력하세요"
                                    className="form-control"
                                />
                                {touched.clientPosition && !account.clientPosition && (
                                    <p style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
                                        필수 입력 항목입니다.
                                    </p>
                                )}
                            </div>
                            <div className="ask-form-item">
                                <label>
                                    이메일 주소 <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    onChange={onChangeAccount}
                                    onBlur={handleBlur}
                                    value={account.email}
                                    placeholder="이메일을 입력하세요"
                                    className="form-control"
                                />
                                {errors.email && (
                                    <p style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>{errors.email}</p>
                                )}
                                {touched.email && !account.email && (
                                    <p style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
                                        필수 입력 항목입니다.
                                    </p>
                                )}
                            </div>
                            <div className="ask-form-item">
                                <label>
                                    예상 사용 인원 <span style={{ color: "red" }}>*</span>
                                </label>
                                <select
                                    className="form-control"
                                    name="companySize"
                                    onChange={onChangeAccount}
                                    onBlur={handleBlur}
                                    value={account.companySize}
                                >
                                    <option value="">선택해주세요.</option>
                                    <option value="10인 이하">10인 이하</option>
                                    <option value="11인 이상 ~ 30인 이하">11인 이상 ~ 30인 이하</option>
                                    <option value="31인 이상 ~ 50인 이하">31인 이상 ~ 50인 이하</option>
                                    <option value="51인 이상 ~ 100인 이하">51인 이상 ~ 100인 이하</option>
                                    <option value="101인 이상~ 500인 이하">101인 이상~ 500인 이하</option>
                                    <option value="501인 이상 ~ 1000인 이하">501인 이상 ~ 1000인 이하</option>
                                    <option value="1000인 이상">1000인 이상</option>
                                </select>
                                {touched.companySize && !account.companySize && (
                                    <p style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
                                        필수 입력 항목입니다.
                                    </p>
                                )}
                            </div>
                            <div className="ask-form-item">
                                <label>내용</label>
                                <textarea
                                    id="content"
                                    name="content"
                                    onChange={onChangeAccount}
                                    value={account.content}
                                    placeholder="문의하실 내용을 입력해주세요."
                                    className="form-control text-control"
                                />
                            </div>
                        </div>
                        <div className="form-footer">
                            <div className="confirm-ck">
                                <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                    <input type="checkbox" checked={isAgreed} onChange={handleAgreementChange} />
                                    고객 문의에 대한 답변 제공 및 현황관리를 위해&nbsp;
                                    <span className="c-link" onClick={() => setModalOpen(true)}>
                                        개인정보의 이용에 동의
                                    </span>
                                    합니다. <span style={{ color: "red" }}>*</span>
                                </label>
                            </div>
                            <div className="askSubmit-box">
                                <button type="submit" className="askBtn">
                                    문의하기
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>

            {modalOpen && (
                <Modal
                    open={modalOpen}
                    close={() => setModalOpen(false)}
                    header="개인정보 이용동의"
                    main={
                        <p>
                            브로넥스는 문의하기 서비스 제공과 관련하여 아래와 같이 <br />
                            개인정보를 수집 및 이용하고 있습니다. <br />
                            <br />
                            수집되는 정보는 해당 목적 이외의 용도로는 이용되지 않습니다.
                            <br />
                            <br />
                            1. 개인정보 수집 목적
                            <br />
                            - 이용자의 신원 확인, 문의사항 확인, 처리결과 통보
                            <br />
                            <br />
                            2. 개인정보 수집 항목 <br />
                            - 이름, 회사명, 직급, 연락처, 이메일
                            <br />
                            <br />
                            3. 개인정보 이용 및 보유기간 <br />
                            개인정보의 수집 및 이용 목적이 달성되거나 이용자의 요청이 있는 경우에는
                            <br />
                            개인정보를 지체 없이 파기합니다.
                            <br />
                            <br />
                            <br />
                            단, 다음의 개인정보 이용 및 보유기간은 아래와 같습니다. <br /> <br />
                            - 분쟁 처리와 관련된정보는 이용자 동의일로부터 3년 <br />- 관계 법령 위반에 따른
                            수사·조사등이 진행중인 경우에는 해당수사·조사 종료 시까지
                        </p>
                    }
                />
            )}
        </>
    );
}
